export default __webpack_public_path__ + "262e6676c4c38e41330f5a7cca8fdac1.png";